export default () => {
  console.warn('[web] stub react-native-circular-progress');
  return null;
};
